import React, { useState } from "react";
import $ from "jquery";

const FAQ = () => {
  const [accordionState, setAccordionState] = useState(false);

  const handleAccordion = (e) => {
    e.preventDefault();
    $(".contents").toggleClass("active");
    setAccordionState(!accordionState);
  };

  return (
    <>
      <div className="qodef-e-inner">
        <div className="qodef-e-media"></div>
        <div className="qodef-e-content">
          <div className="qodef-e-text">
            <div
              data-elementor-type="wp-post"
              data-elementor-id={62}
              className="elementor elementor-62"
              data-elementor-settings="[]"
            >
              <div className="elementor-inner">
                <div className="elementor-section-wrap wrapper-c">
                  <div className="banner">
                    <button
                      className="banner__content"
                      onClick={handleAccordion}
                    >
                      FAQ
                      {!accordionState ? (
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M9 6L15 12L9 18"
                            stroke="white"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      ) : (
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M6 9L12 15L18 9"
                            stroke="white"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      )}
                    </button>
                    <div className="contents">
                      <section
                        className="elementor-section elementor-top-section elementor-element elementor-element-18c7526 elementor-section-boxed elementor-section-height-default elementor-section-height-default qodef-elementor-content-no"
                        data-id="18c7526"
                        data-element_type="section"
                      >
                        <div className="elementor-container elementor-column-gap-default">
                          <div className="elementor-row">
                            <div
                              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-7b7b1b20"
                              data-id="7b7b1b20"
                              data-element_type="column"
                            >
                              <div className="elementor-column-wrap elementor-element-populated">
                                <div className="elementor-widget-wrap">
                                  <div
                                    className="elementor-element elementor-element-66c62145 elementor-widget elementor-widget-swissdelight_core_section_title"
                                    data-id="66c62145"
                                    data-element_type="widget"
                                    data-widget_type="swissdelight_core_section_title.default"
                                  >
                                    <div className="elementor-widget-container">
                                      <div className="qodef-shortcode qodef-m qodef-section-title qodef-alignment--left qodef-appear-animation--enabled qodef--appeared">
                                        <h6 className="qodef-m-title">
                                          1. Is this safe for kids?
                                        </h6>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                      <section
                        className="elementor-section elementor-top-section elementor-element elementor-element-71ad9e80 elementor-section-boxed elementor-section-height-default elementor-section-height-default qodef-elementor-content-no"
                        data-id="71ad9e80"
                        data-element_type="section"
                      >
                        <div className="elementor-container elementor-column-gap-default">
                          <div className="elementor-row">
                            <div
                              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-3e7827ab"
                              data-id="3e7827ab"
                              data-element_type="column"
                            >
                              <div className="elementor-column-wrap elementor-element-populated">
                                <div className="elementor-widget-wrap">
                                  <div
                                    className="elementor-element elementor-element-63cc8c6e elementor-widget elementor-widget-text-editor"
                                    data-id="63cc8c6e"
                                    data-element_type="widget"
                                    data-widget_type="text-editor.default"
                                  >
                                    <div className="elementor-widget-container">
                                      <div className="elementor-text-editor elementor-clearfix">
                                        <p>
                                          Yes! Sun Kissed Delight is suitable
                                          for children. It’s easy to consume,
                                          tastes great, and offers better
                                          absorption than many alternatives
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                      <section
                        className="elementor-section elementor-top-section elementor-element elementor-element-18c7526 elementor-section-boxed elementor-section-height-default elementor-section-height-default qodef-elementor-content-no"
                        data-id="18c7526"
                        data-element_type="section"
                      >
                        <div className="elementor-container elementor-column-gap-default">
                          <div className="elementor-row">
                            <div
                              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-7b7b1b20"
                              data-id="7b7b1b20"
                              data-element_type="column"
                            >
                              <div className="elementor-column-wrap elementor-element-populated">
                                <div className="elementor-widget-wrap">
                                  <div
                                    className="elementor-element elementor-element-66c62145 elementor-widget elementor-widget-swissdelight_core_section_title"
                                    data-id="66c62145"
                                    data-element_type="widget"
                                    data-widget_type="swissdelight_core_section_title.default"
                                  >
                                    <div className="elementor-widget-container">
                                      <div className="qodef-shortcode qodef-m qodef-section-title qodef-alignment--left qodef-appear-animation--enabled qodef--appeared">
                                        <h6 className="qodef-m-title">
                                          2. Can I take this with other
                                          supplements or medicines?
                                        </h6>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                      <section
                        className="elementor-section elementor-top-section elementor-element elementor-element-71ad9e80 elementor-section-boxed elementor-section-height-default elementor-section-height-default qodef-elementor-content-no"
                        data-id="71ad9e80"
                        data-element_type="section"
                      >
                        <div className="elementor-container elementor-column-gap-default">
                          <div className="elementor-row">
                            <div
                              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-3e7827ab"
                              data-id="3e7827ab"
                              data-element_type="column"
                            >
                              <div className="elementor-column-wrap elementor-element-populated">
                                <div className="elementor-widget-wrap">
                                  <div
                                    className="elementor-element elementor-element-63cc8c6e elementor-widget elementor-widget-text-editor"
                                    data-id="63cc8c6e"
                                    data-element_type="widget"
                                    data-widget_type="text-editor.default"
                                  >
                                    <div className="elementor-widget-container">
                                      <div className="elementor-text-editor elementor-clearfix">
                                        <p>
                                          In most cases, yes — but we recommend
                                          checking with your healthcare provider
                                          to avoid excess Vitamin D or
                                          interactions with other medications.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                      <section
                        className="elementor-section elementor-top-section elementor-element elementor-element-18c7526 elementor-section-boxed elementor-section-height-default elementor-section-height-default qodef-elementor-content-no"
                        data-id="18c7526"
                        data-element_type="section"
                      >
                        <div className="elementor-container elementor-column-gap-default">
                          <div className="elementor-row">
                            <div
                              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-7b7b1b20"
                              data-id="7b7b1b20"
                              data-element_type="column"
                            >
                              <div className="elementor-column-wrap elementor-element-populated">
                                <div className="elementor-widget-wrap">
                                  <div
                                    className="elementor-element elementor-element-66c62145 elementor-widget elementor-widget-swissdelight_core_section_title"
                                    data-id="66c62145"
                                    data-element_type="widget"
                                    data-widget_type="swissdelight_core_section_title.default"
                                  >
                                    <div className="elementor-widget-container">
                                      <div className="qodef-shortcode qodef-m qodef-section-title qodef-alignment--left qodef-appear-animation--enabled qodef--appeared">
                                        <h6 className="qodef-m-title">
                                          3. What does “IU” mean?
                                        </h6>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                      <section
                        className="elementor-section elementor-top-section elementor-element elementor-element-71ad9e80 elementor-section-boxed elementor-section-height-default elementor-section-height-default qodef-elementor-content-no"
                        data-id="71ad9e80"
                        data-element_type="section"
                      >
                        <div className="elementor-container elementor-column-gap-default">
                          <div className="elementor-row">
                            <div
                              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-3e7827ab"
                              data-id="3e7827ab"
                              data-element_type="column"
                            >
                              <div className="elementor-column-wrap elementor-element-populated">
                                <div className="elementor-widget-wrap">
                                  <div
                                    className="elementor-element elementor-element-63cc8c6e elementor-widget elementor-widget-text-editor"
                                    data-id="63cc8c6e"
                                    data-element_type="widget"
                                    data-widget_type="text-editor.default"
                                  >
                                    <div className="elementor-widget-container">
                                      <div className="elementor-text-editor elementor-clearfix">
                                        <p>
                                          IU stands for International Unit—a
                                          standard way to measure the amount of
                                          vitamins and other biologically active
                                          substances. In the case of Vitamin D,
                                          it tells you the strength or potency
                                          of each chocolate.
                                        </p>
                                        <p>
                                          For example, our chocolates come in
                                          3500 IU (moderate) and 15000 IU
                                          (higher strength) formats.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                      <section
                        className="elementor-section elementor-top-section elementor-element elementor-element-18c7526 elementor-section-boxed elementor-section-height-default elementor-section-height-default qodef-elementor-content-no"
                        data-id="18c7526"
                        data-element_type="section"
                      >
                        <div className="elementor-container elementor-column-gap-default">
                          <div className="elementor-row">
                            <div
                              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-7b7b1b20"
                              data-id="7b7b1b20"
                              data-element_type="column"
                            >
                              <div className="elementor-column-wrap elementor-element-populated">
                                <div className="elementor-widget-wrap">
                                  <div
                                    className="elementor-element elementor-element-66c62145 elementor-widget elementor-widget-swissdelight_core_section_title"
                                    data-id="66c62145"
                                    data-element_type="widget"
                                    data-widget_type="swissdelight_core_section_title.default"
                                  >
                                    <div className="elementor-widget-container">
                                      <div className="qodef-shortcode qodef-m qodef-section-title qodef-alignment--left qodef-appear-animation--enabled qodef--appeared">
                                        <h6 className="qodef-m-title">
                                          4. How often should I consume it?
                                        </h6>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                      <section
                        className="elementor-section elementor-top-section elementor-element elementor-element-71ad9e80 elementor-section-boxed elementor-section-height-default elementor-section-height-default qodef-elementor-content-no"
                        data-id="71ad9e80"
                        data-element_type="section"
                      >
                        <div className="elementor-container elementor-column-gap-default">
                          <div className="elementor-row">
                            <div
                              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-3e7827ab"
                              data-id="3e7827ab"
                              data-element_type="column"
                            >
                              <div className="elementor-column-wrap elementor-element-populated">
                                <div className="elementor-widget-wrap">
                                  <div
                                    className="elementor-element elementor-element-63cc8c6e elementor-widget elementor-widget-text-editor"
                                    data-id="63cc8c6e"
                                    data-element_type="widget"
                                    data-widget_type="text-editor.default"
                                  >
                                    <div className="elementor-widget-container">
                                      <div className="elementor-text-editor elementor-clearfix">
                                        <p>
                                          That depends on your health, age, and
                                          Vitamin D levels. But for and average
                                          adult 1000 IU per day is required for
                                          maintenance.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                      <section
                        className="elementor-section elementor-top-section elementor-element elementor-element-18c7526 elementor-section-boxed elementor-section-height-default elementor-section-height-default qodef-elementor-content-no"
                        data-id="18c7526"
                        data-element_type="section"
                      >
                        <div className="elementor-container elementor-column-gap-default">
                          <div className="elementor-row">
                            <div
                              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-7b7b1b20"
                              data-id="7b7b1b20"
                              data-element_type="column"
                            >
                              <div className="elementor-column-wrap elementor-element-populated">
                                <div className="elementor-widget-wrap">
                                  <div
                                    className="elementor-element elementor-element-66c62145 elementor-widget elementor-widget-swissdelight_core_section_title"
                                    data-id="66c62145"
                                    data-element_type="widget"
                                    data-widget_type="swissdelight_core_section_title.default"
                                  >
                                    <div className="elementor-widget-container">
                                      <div className="qodef-shortcode qodef-m qodef-section-title qodef-alignment--left qodef-appear-animation--enabled qodef--appeared">
                                        <h6 className="qodef-m-title">
                                          5. What if I forget to take it?
                                        </h6>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                      <section
                        className="elementor-section elementor-top-section elementor-element elementor-element-71ad9e80 elementor-section-boxed elementor-section-height-default elementor-section-height-default qodef-elementor-content-no"
                        data-id="71ad9e80"
                        data-element_type="section"
                      >
                        <div className="elementor-container elementor-column-gap-default">
                          <div className="elementor-row">
                            <div
                              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-3e7827ab"
                              data-id="3e7827ab"
                              data-element_type="column"
                            >
                              <div className="elementor-column-wrap elementor-element-populated">
                                <div className="elementor-widget-wrap">
                                  <div
                                    className="elementor-element elementor-element-63cc8c6e elementor-widget elementor-widget-text-editor"
                                    data-id="63cc8c6e"
                                    data-element_type="widget"
                                    data-widget_type="text-editor.default"
                                  >
                                    <div className="elementor-widget-container">
                                      <div className="elementor-text-editor elementor-clearfix">
                                        <p>
                                          No problem—just pick up from where you
                                          left off. Since it’s not a daily dose,
                                          it’s easier to stay consistent without
                                          stress
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                      <section
                        className="elementor-section elementor-top-section elementor-element elementor-element-18c7526 elementor-section-boxed elementor-section-height-default elementor-section-height-default qodef-elementor-content-no"
                        data-id="18c7526"
                        data-element_type="section"
                      >
                        <div className="elementor-container elementor-column-gap-default">
                          <div className="elementor-row">
                            <div
                              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-7b7b1b20"
                              data-id="7b7b1b20"
                              data-element_type="column"
                            >
                              <div className="elementor-column-wrap elementor-element-populated">
                                <div className="elementor-widget-wrap">
                                  <div
                                    className="elementor-element elementor-element-66c62145 elementor-widget elementor-widget-swissdelight_core_section_title"
                                    data-id="66c62145"
                                    data-element_type="widget"
                                    data-widget_type="swissdelight_core_section_title.default"
                                  >
                                    <div className="elementor-widget-container">
                                      <div className="qodef-shortcode qodef-m qodef-section-title qodef-alignment--left qodef-appear-animation--enabled qodef--appeared">
                                        <h6 className="qodef-m-title">
                                          6. Is it sugar-free?
                                        </h6>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                      <section
                        className="elementor-section elementor-top-section elementor-element elementor-element-71ad9e80 elementor-section-boxed elementor-section-height-default elementor-section-height-default qodef-elementor-content-no"
                        data-id="71ad9e80"
                        data-element_type="section"
                      >
                        <div className="elementor-container elementor-column-gap-default">
                          <div className="elementor-row">
                            <div
                              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-3e7827ab"
                              data-id="3e7827ab"
                              data-element_type="column"
                            >
                              <div className="elementor-column-wrap elementor-element-populated">
                                <div className="elementor-widget-wrap">
                                  <div
                                    className="elementor-element elementor-element-63cc8c6e elementor-widget elementor-widget-text-editor"
                                    data-id="63cc8c6e"
                                    data-element_type="widget"
                                    data-widget_type="text-editor.default"
                                  >
                                    <div className="elementor-widget-container">
                                      <div className="elementor-text-editor elementor-clearfix">
                                        <p>
                                          We offer both regular and sugar-free
                                          options — so you can choose what suits
                                          your lifestyle best.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                      <section
                        className="elementor-section elementor-top-section elementor-element elementor-element-18c7526 elementor-section-boxed elementor-section-height-default elementor-section-height-default qodef-elementor-content-no"
                        data-id="18c7526"
                        data-element_type="section"
                      >
                        <div className="elementor-container elementor-column-gap-default">
                          <div className="elementor-row">
                            <div
                              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-7b7b1b20"
                              data-id="7b7b1b20"
                              data-element_type="column"
                            >
                              <div className="elementor-column-wrap elementor-element-populated">
                                <div className="elementor-widget-wrap">
                                  <div
                                    className="elementor-element elementor-element-66c62145 elementor-widget elementor-widget-swissdelight_core_section_title"
                                    data-id="66c62145"
                                    data-element_type="widget"
                                    data-widget_type="swissdelight_core_section_title.default"
                                  >
                                    <div className="elementor-widget-container">
                                      <div className="qodef-shortcode qodef-m qodef-section-title qodef-alignment--left qodef-appear-animation--enabled qodef--appeared">
                                        <h6 className="qodef-m-title">
                                          7. Where can I buy it?
                                        </h6>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                      <section
                        className="elementor-section elementor-top-section elementor-element elementor-element-71ad9e80 elementor-section-boxed elementor-section-height-default elementor-section-height-default qodef-elementor-content-no"
                        data-id="71ad9e80"
                        data-element_type="section"
                      >
                        <div className="elementor-container elementor-column-gap-default">
                          <div className="elementor-row">
                            <div
                              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-3e7827ab"
                              data-id="3e7827ab"
                              data-element_type="column"
                            >
                              <div className="elementor-column-wrap elementor-element-populated">
                                <div className="elementor-widget-wrap">
                                  <div
                                    className="elementor-element elementor-element-63cc8c6e elementor-widget elementor-widget-text-editor"
                                    data-id="63cc8c6e"
                                    data-element_type="widget"
                                    data-widget_type="text-editor.default"
                                  >
                                    <div className="elementor-widget-container">
                                      <div className="elementor-text-editor elementor-clearfix">
                                        <p>
                                          The 3500 IU variants are available
                                          online (website & social media). The
                                          15000 IU chocolates are available
                                          through hospitals, clinics, or contact
                                          us for bulk orders.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                      <section
                        className="elementor-section elementor-top-section elementor-element elementor-element-18c7526 elementor-section-boxed elementor-section-height-default elementor-section-height-default qodef-elementor-content-no"
                        data-id="18c7526"
                        data-element_type="section"
                      >
                        <div className="elementor-container elementor-column-gap-default">
                          <div className="elementor-row">
                            <div
                              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-7b7b1b20"
                              data-id="7b7b1b20"
                              data-element_type="column"
                            >
                              <div className="elementor-column-wrap elementor-element-populated">
                                <div className="elementor-widget-wrap">
                                  <div
                                    className="elementor-element elementor-element-66c62145 elementor-widget elementor-widget-swissdelight_core_section_title"
                                    data-id="66c62145"
                                    data-element_type="widget"
                                    data-widget_type="swissdelight_core_section_title.default"
                                  >
                                    <div className="elementor-widget-container">
                                      <div className="qodef-shortcode qodef-m qodef-section-title qodef-alignment--left qodef-appear-animation--enabled qodef--appeared">
                                        <h6 className="qodef-m-title">
                                          8. What if I eat more than I should?
                                        </h6>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                      <section
                        className="elementor-section elementor-top-section elementor-element elementor-element-71ad9e80 elementor-section-boxed elementor-section-height-default elementor-section-height-default qodef-elementor-content-no"
                        data-id="71ad9e80"
                        data-element_type="section"
                      >
                        <div className="elementor-container elementor-column-gap-default">
                          <div className="elementor-row">
                            <div
                              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-3e7827ab"
                              data-id="3e7827ab"
                              data-element_type="column"
                            >
                              <div className="elementor-column-wrap elementor-element-populated">
                                <div className="elementor-widget-wrap">
                                  <div
                                    className="elementor-element elementor-element-63cc8c6e elementor-widget elementor-widget-text-editor"
                                    data-id="63cc8c6e"
                                    data-element_type="widget"
                                    data-widget_type="text-editor.default"
                                  >
                                    <div className="elementor-widget-container">
                                      <div className="elementor-text-editor elementor-clearfix">
                                        <p>
                                          Vitamin D toxicity is extremely rare
                                          and usually only occurs when very high
                                          doses are consumed regularly over
                                          time—far more than a single Sun Kissed
                                          Delight chocolate provides.
                                        </p>
                                        <p>
                                          That said, Vitamin D is stored in the
                                          body, so it's still best not to overdo
                                          it. If you’ve taken more than advised
                                          by mistake, there's typically no cause
                                          for concern—but feel free to consult
                                          your doctor for peace of mind.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FAQ;
